
import { defineComponent, onMounted } from 'vue'
import { android, ios } from '@/core/utils/ua'
interface LoginProp {
  isLogin: boolean
  userInfo: unknown
  errCode: number
}
export default defineComponent({
  name: 'Login',
  emits: ['on-success', 'on-cancel'],
  setup(_, { emit }) {
    onMounted(() => {
      let iconUrl
      if (android) {
        iconUrl = `https://qngtimgcom-75603.gzc.vod.tencent-cloud.com/_dasheng_/20201013/5a035fa595439d31715356f983e8cd57.lottie`
      } else if (ios) {
        iconUrl = `http://s.inews.gtimg.com/inewsapp/QQNews/lotties/qiandao_tanchuang_red.zip`
      }
      const headerInfo = {
        iconUrl,
        title: `<font color='#000000'>登录领取烟花红包</font>`,
        desc: '送你新年好运气'
      }
      if (window.TencentNews) {
        window.TencentNews.invoke('login', {
          type: 'qqorweixin',
          userInfo: { id: 'fakeid' },
          headerInfo,
          from: JSON.stringify({
            from: 'firework_redpack',
            activityId: 'yanhua'
          }),
          onCallback(ret: LoginProp) {
            if (ret.isLogin) {
              emit('on-success')
            } else {
              emit('on-cancel')
            }
          }
        })
      }
    })
  }
})
